<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="四选一礼包" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardEggEdit:import'"
                  :export-p="'config:rewardEggEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="center" label="体力参数" width="150">
                <template v-slot:default="{row}">
                  <el-input v-model="row.spinCe" placeholder="体力参数" />
                </template>
              </el-table-column>
              <el-table-column label="关卡修正系数配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.stageCeId">
                    <el-option v-for="item in list[3]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="复活间隔配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.reliveIntervalId">
                    <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="复活礼包配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.resurrectionGiftId">
                    <el-option v-for="item in list[4]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="奖励配置" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rewardId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <el-button v-permisaction="['config:rewardEggEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardEggEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardEggEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>

      </el-card>

      <el-card>
        <div slot="header" class="clearfix">
          <span>随机系数</span>
          <el-row :gutter="10">
            <CommonExcel
              ref="CommonExcelRef"
              :import-p="'config:rewardEggEdit:import'"
              :export-p="'config:rewardEggEdit:export'"
              :import-method="importBaseCfg2"
              :export-method="exportBaseCfg2"
            />
          </el-row>
        </div>
        <el-table :data="stage_reward.randConf" border stripe style="width: 50%">
          <el-table-column label="类型">
            <template v-slot:default="scope">
              <span v-if="scope.$index === 0">低等级</span>
              <span v-else>高等级</span>
            </template>
          </el-table-column>
          <el-table-column prop="min" label="等级范围">
            <template v-slot:default="scope">
              <el-input v-model="scope.row.min" style="width: 45%" />
              -
              <el-input v-model="scope.row.max" style="width: 45%" />
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" style="margin-top: 10px" size="mini" :disabled="isOnline === 1" @click="stageRewardSumit()">保存</el-button>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>保护配置</span>
          <el-row :gutter="10">
            <CommonExcel
              ref="CommonExcelRef"
              :import-p="'config:rewardEggEdit:import'"
              :export-p="'config:rewardEggEdit:export'"
              :import-method="importBaseCfg3"
              :export-method="exportBaseCfg3"
            />
          </el-row>
        </div>
        <el-form :inline="true">
          <el-table :data="stage_reward.protect" border stripe>
            <el-table-column prop="lvMin" label="等级范围" width="200px">
              <template v-slot:default="scope">
                <el-input v-model="scope.row.lvMin" style="width: 40%" />
                -
                <el-input v-model="scope.row.lvMax" style="width: 40%" />
              </template>
            </el-table-column>
            <el-table-column prop="m" label="产出系数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.m" placeholder="产出系数" />
              </template>
            </el-table-column>
            <el-table-column prop="maxBet" label="上限倍率">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.maxBet" placeholder="上限倍率" />
              </template>
            </el-table-column>

            <el-table-column prop="minBet" label="下限倍率">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.minBet" placeholder="下限倍率" />
              </template>
            </el-table-column>

            <el-table-column prop="stage" label="保护层数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" placeholder="保护层数" />
              </template>
            </el-table-column>

            <el-table-column prop="ce" label="保护基数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.ce" placeholder="保护基数" />
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot:default="scope">
                <el-button type="danger" size="mini" @click="stageRewardDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="mini" style="margin-top: 10px" type="primary" @click="stageRewardAdd()">+</el-button>
        </el-form>

        <el-button type="primary" style="margin-top: 10px" size="mini" :disabled="isOnline === 1" @click="stageRewardSumit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import {
  getActivityList, getActivityStageRewardCfg,
  updateActivityRewardConfData, updateActivityStageRewardCfg
} from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'RewardEggEdit',
  components: { CommonExcel },
  data() {
    return {
      protectDialogVisible: false,
      extremeDialogVisible: false,
      newExtremeDialogVisible: false,
      stage_reward: {
        rand: {
          min: 0,
          max: 0
        },
        randConf: [
          { min: 0, max: 0 },
          { min: 0, max: 0 }
        ],
        protect: [{
          lv: 0,
          lvMin: 0,
          lvMax: 0,
          m: 0,
          maxBet: 0,
          minBet: 0,
          stage: 0,
          ce: 0
        }],
        confType: 1
      },
      limitType: [2],
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'easter_egg',
      rewardConf: [],
      shopSku: [],
      isOnline: 0
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.curClass = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getStageReward()
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      const data = JSON.stringify(this.baseList)
      updateActivityRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivityList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          let baseList = res.data.list[0].reward_conf
          if (typeof baseList === 'object' && !Array.isArray(baseList)) {
            baseList = []
          }
          this.baseList = baseList
          const exportData = []
          for (const i in res.data.list[0].extraData) {
            exportData.push(res.data.list[0].extraData[i])
          }
          this.extra_data = exportData
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg2(excelInfo) {
      const excelData = excelInfo.data
      this.stage_reward.randConf = this.$refs.CommonExcelRef.tranToTarget(excelData[0].sheetData, { }, true, 'name', 'id')
    },
    importBaseCfg3(excelInfo) {
      const excelData = excelInfo.data
      this.stage_reward.protect = this.$refs.CommonExcelRef.tranToTarget(excelData[0].sheetData, { }, true, 'name', 'id')
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg2() {
      this.exportBaseCfg(2)
    },
    exportBaseCfg3() {
      this.exportBaseCfg(3)
    },
    exportBaseCfg(type) {
      let fileName = '四选一配置'
      const hearer = []
      const excelData = []
      const name = ['四选一配置']
      let data = {}
      let tranTitle = {}
      let listArr = []
      switch (type) {
        case 2:
          fileName = '随机系数'
          listArr = this.stage_reward.randConf
          data = { }
          tranTitle = { min: '最小等级', max: '最大等级' }
          break
        case 3:
          fileName = '保护配置'
          listArr = this.stage_reward.protect
          data = { groupIds: this.groupsList, rewardId: this.list[2] }
          tranTitle = { lvMin: '最小等级', lvMax: '最大等级', m: '产出系数', maxBet: '上限倍率', minBet: '下限倍率', stage: '保护层数', ce: '保护基数' }
          break

        default:
          listArr = this.baseList
          data = { groupIds: this.groupsList, rewardId: this.list[2] }
          tranTitle = { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, spinCe: '体力参数', reliveIntervalId: '复活间隔配置', stageCeId: '关卡修正系数', resurrectionGiftId: '复活礼包', rewardId: '奖励配置' }
          break
      }
      const list = this.$refs.CommonExcelRef.tranToTarget(listArr, data, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, tranTitle)
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    stageRewardDel(index) {
      this.stage_reward.protect = this.stage_reward.protect.filter((item, i) => {
        return index !== i
      })
    },
    stageRewardSumit() {
      const newStageReward = Object.assign({}, this.stage_reward)
      if (newStageReward.confType === 0) {
        if (this.stage_reward.rand.min > this.stage_reward.rand.max) {
          this.msgError('随机系数最小值不能大于最大值')
          return
        }
      } else {
        const randConf = {}
        let index = 0
        for (const i in this.stage_reward.randConf) {
          index++
          const val = this.stage_reward.randConf[i]
          if (val.min > val.max) {
            this.msgError('随机系数最小值不能大于最大值')
            return
          }

          randConf[index] = val
        }

        newStageReward.randConf = randConf
      }

      const protect = {}
      let index = 0
      for (const i in newStageReward.protect) {
        index++
        const val = newStageReward.protect[i]
        // if (val.lv <= 0) {
        //   this.msgError('保护配置-用户等级不能小于等于0')
        //   return
        // }

        if (val.lvMin <= 0) {
          this.msgError('保护配置-用户等级起始值不能小于等于0')
          return
        }

        if (val.lvMax <= 0) {
          this.msgError('保护配置-用户等级起始值不能小于等于0')
          return
        }

        if (val.lvMin > val.lvMax) {
          this.msgError('保护配置-用户等级起始值不能大于用户等级结束值')
          return
        }

        if (val.m <= 0) {
          this.msgError('保护配置-产出系数不能小于0')
          return
        }

        if (val.maxBet <= 0) {
          this.msgError('保护配置-上限倍率不能小于0')
          return
        }

        if (val.minBet <= 0) {
          this.msgError('保护配置-下限倍率不能小于0')
          return
        }

        if (val.stage <= 0) {
          this.msgError('保护配置-保护层数不能小于0')
          return
        }

        if (val.ce <= 0) {
          this.msgError('保护配置-保护基数不能小于0')
          return
        }

        protect[index] = val
      }
      newStageReward.protect = protect
      const postData = { type: this.actType, aid: this.aid, reward: newStageReward }
      const data = JSON.stringify(postData)
      updateActivityStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getStageReward()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    stageRewardAdd() {
      this.stage_reward.protect.push({
        lv: 0,
        lvMin: 0,
        lvMax: 0,
        m: 0,
        maxBet: 0,
        minBet: 0,
        stage: 0,
        ce: 0
      })
    },
    getStageReward() {
      getActivityStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          if (res.data.reward) {
            const reward = res.data.reward
            const randConf = []
            const protect = []
            for (const i in reward.randConf) {
              const val = reward.randConf[i]
              randConf.push(val)
            }
            for (const i in reward.protect) {
              const val = reward.protect[i]
              protect.push(val)
            }
            this.stage_reward.confType = reward.confType
            this.stage_reward.randConf = randConf
            this.stage_reward.rand = reward.rand
            this.stage_reward.protect = protect
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
